// Core Imports
import { Fragment } from 'react';
import { useParams } from 'react-router';
import { t } from 'i18next';

// Component Imports
import { Col, Row } from 'antd';
import DocumentTitle from '../components/DocumentTitle';
import Permissioned from '../components/Permissioned';
import OrganizationIntegrationsTable from '../components/Tables/OrganizationIntegrationsTable';

// Misc Imports
import useUserPermissions from '../utils/hooks/useUserPermissions';
import { PERMISSIONS_GROUP_VIEWER } from '../constants/main';

const OrganizationIntegrationsScreen = () => {
  const { orgId } = useParams();
  const userPermissions = useUserPermissions(orgId, null);

  return (
    <Fragment>
      <DocumentTitle title={t('Integrations')} />

      <Permissioned
        allowedPermissions={PERMISSIONS_GROUP_VIEWER}
        currentPermissions={userPermissions}
      >
        <Row gutter={24}>
          <Col span={24}>
            <OrganizationIntegrationsTable />
          </Col>
        </Row>
      </Permissioned>
    </Fragment>
  );
};

export default OrganizationIntegrationsScreen;
